/* eslint-disable react/prop-types */
import { Button, Form, Modal } from "react-bootstrap"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
    getApplicationThreadedComments,
    postApplicationThreadedComments,
    reviewThreadedComments
} from "../../../data/applicationSlice"
import { getCurrentUser } from "../../../data/authenticationSlice"
import Loader from "../../../components/Loader"
import { css } from "@emotion/react"

const componentStyled = css`
    .hr-custom {
        width: 50%;
        margin: 0 auto;
    }
`

export const ApplicationThreadedComments = ({ show, hide, currentAppId, hasAdminView }) => {
    const dispatch = useDispatch()

    const { threadedComments, totalRecordsOfComments, fetchStatus } = useSelector((state) => state.application)
    const { user, fetchStatus: userFetchStatus } = useSelector((state) => state.authentication)

    const [comment, setComment] = useState("")

    useEffect(() => {
        if (currentAppId && show) {
            dispatch(getApplicationThreadedComments(currentAppId)).then(({ payload }) => {
                if (!hasAdminView && payload?.totalRecords > 0) {
                    const notReviewedComments =
                        payload?.records.filter((comment) => !comment.isReviewed).map((comment) => comment.id) || []
                    if (notReviewedComments?.length > 0) {
                        dispatch(reviewThreadedComments(notReviewedComments))
                    }
                }
            })
        }
    }, [currentAppId, show])

    useEffect(() => {
        !user && hasAdminView && dispatch(getCurrentUser())
    }, [])

    const postComment = () => {
        dispatch(
            postApplicationThreadedComments({
                name: user?.firstName,
                applicationId: currentAppId,
                content: comment
            })
        ).then(({ payload: succeeded }) => {
            if (succeeded) {
                setComment("")
                hide()
            }
        })
    }

    return (
        <Modal
            show={show}
            onHide={hide}
            size="lg"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Threaded Comments</Modal.Title>
            </Modal.Header>
            <Modal.Body css={componentStyled}>
                <Loader show={fetchStatus === "loading" || userFetchStatus === "loading"} />
                {threadedComments?.length === 0 && fetchStatus === "success" && !hasAdminView && (
                    <p className="mt-2 pt-1 text-center h5">No Results</p>
                )}
                <div
                    style={{
                        maxHeight: "70vh",
                        overflowY: "auto",
                        paddingRight: "5px"
                    }}>
                    {threadedComments?.map((comment, index) => (
                        <div
                            key={index}
                            className="mb-2 border p-2">
                            <strong>{comment?.from?.firstName || ""} :</strong>
                            <span> {comment?.content || ""}</span>
                        </div>
                    ))}
                    {hasAdminView && (
                        <>
                            {threadedComments?.length > 0 && <hr className="my-4 hr-custom" />}
                            <Form.Control
                                as="textarea"
                                className="form-control-sm mb-3"
                                placeholder="Leave a comment here"
                                style={{ height: "100px" }}
                                value={comment || ""}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </>
                    )}
                </div>
            </Modal.Body>
            {hasAdminView && (
                <Modal.Footer>
                    <Button
                        className="btn-sm"
                        variant="primary"
                        onClick={postComment}
                        disabled={!comment}>
                        Post Comment
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    )
}
